/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import {
  type FormArray,
  FormBuilder,
  type FormGroup,
  FormGroupDirective,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID, ViewChild, type OnInit } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { catchError, EMPTY } from 'rxjs';
import { emailValidator } from '../../shared/validators/email.validator';
import { undeliverableValidator } from '../../shared/validators/undeliverable.validator';

// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CmsService } from '../../shared/services/cms.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from '../../shared/services/util.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from '../../shared/services/storage.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { AccountService } from '../../shared/services/account.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { NotificationsService } from '../../shared/services/notifications.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CustomerService } from '../../shared/services/customer.service';

// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatError, MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';

import { StorageEnum } from '../../shared/enums/storage.enum';
import { type AccountDetail } from '../../shared/models/account-detail';
import { SidePanelComponent } from '../../shared/components/side-panel/side-panel.component';
import { EmailInfo } from '../../shared/models/email-info';
import { PhoneInfo } from '../../shared/models/phone-info';
import { Nav } from '../../shared/enums/nav.enum';
import { NotificationType } from '../../shared/enums/notificationtype.enum';
import { NotificationComponent } from '../../shared/components/notification/notification.component';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { PageHeader } from '../../shared/models/page-header.model';
import { CreateCustomerContact } from '../../shared/models/create-customer-contact';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { SeoService } from '../../shared/services/seo.service';

@Component({
  selector: 'app-contact-info',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatCardModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatButtonModule,
    MatDividerModule,
    SidePanelComponent,
    MatError,
    NotificationComponent,
    PageHeaderComponent,
  ],
  templateUrl: './contact-info.component.html',
  styleUrl: './contact-info.component.scss',
})
export class ContactInfoComponent implements OnInit {
  pageReady = false;
  pageLabels: any;
  emailInlineErrors: any;
  isBrowser = false;
  accountDetail: AccountDetail;
  existingEmailsForm: FormArray;
  contactForm: FormGroup;
  existingPhonesForm: FormArray;
  phoneContactForm: FormGroup;
  newEmailForm: FormGroup;
  newPhoneForm: FormGroup;
  deletePaymentAssociatedAutoPay: string = '';
  @ViewChild(MatAccordion) accordion!: MatAccordion;
  sidePanelData: any = null;
  emailList: EmailInfo[] = [];
  showUpdateUndeliverableMessage = false;
  pageName = 'Contact Info';
  phoneList: PhoneInfo[];
  headerData = new PageHeader();

  constructor(
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) readonly platformId: Object,
    private readonly cms: CmsService,
    public dialog: MatDialog,
    private readonly fb: FormBuilder,
    private readonly storage: StorageService,
    private readonly utils: UtilService,
    private readonly account: AccountService,
    private readonly customer: CustomerService,
    private readonly router: Router,
    private readonly notifi: NotificationsService,
    private readonly seoS: SeoService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    this.accountDetail = this.storage.getSession(StorageEnum.AccountDetail);
    this.existingEmailsForm = this.fb.array([]);
    this.contactForm = this.fb.group({
      EmailForms: this.existingEmailsForm,
    });
    this.newEmailForm = this.fb.group({
      newEmail: ['', [Validators.required, emailValidator()]],
      newEmailConfirm: ['', Validators.required],
    });
    this.newPhoneForm = this.fb.group({
      newNumber: ['', [Validators.required]],
      newType: [0],
      newPrimary: [false],
    });
    this.emailList = this.getEmailList();
    this.existingPhonesForm = this.fb.array([]);
    this.phoneContactForm = this.fb.group({
      PhoneForms: this.existingPhonesForm,
    });
    this.phoneList = this.getPhoneList();
  }

  ngOnInit(): void {
    this.cms.getContent('oas-contact-information', 'Contact Info').subscribe((data: any) => {
      this.pageLabels = JSON.parse(JSON.stringify(data));
      this.headerData.Message = this.pageLabels.pageHeadlineText;
      this.emailInlineErrors = this.pageLabels.emailInlineErrors.value.data;
      this.sidePanelData = this.pageLabels.sidePanelData.value.data;
      this.seoS.setSeoTags(data.seo);

      if (this.isBrowser) {
        this.mapEmails();
        this.mapPhones();
        this.displayPreNotifications();
        this.pageReady = true;
        this.utils.hideSpinner();
      }
    });
  }

  displayPreNotifications(): void {
    let prenotificationText = this.pageLabels.defaultPrenotificationMessage;

    if (this.emailList.length === 0 && this.phoneList.length === 0) {
      prenotificationText = this.pageLabels.noEmailOrPhonePrenotificationMessage;
    } else if (this.emailList.length === 0) {
      prenotificationText = this.pageLabels.noEmailPrenotificationMessage;
    } else if (this.phoneList.length === 0) {
      prenotificationText = this.pageLabels.noPhonePrenotificationMessage;
    }
    const undeliverableOnFile = this.emailList.filter((email: EmailInfo) => {
      return email.Type !== 'EMAIL';
    });
    if (undeliverableOnFile.length > 0) {
      prenotificationText = this.pageLabels.undeliverableEmailPrenotificationMessage;
    }
    this.notifi.addNotification(prenotificationText, NotificationType.Prenotification, this.pageName);
  }

  setSidePanelData(panelArray: any[]): void {
    if (this.accountDetail.IsAutoPay) {
      this.sidePanelData = panelArray.find((panel) => {
        return panel.panelData.value.name === 'Autopay Change Panel';
      })?.panelData?.value?.data;
    } else {
      this.sidePanelData = panelArray.find((panel) => {
        return panel.panelData.value.name === 'Autopay Enroll Panel';
      })?.panelData?.value?.data;
    }
  }

  mapEmails(): void {
    let emailForm, defaultForm;
    if (this.emailList.length > 0) {
      this.emailList.map((email) => {
        emailForm = this.fb.group({
          ExistingEmail: [email.Email, [Validators.required, emailValidator()]],
          SetPrimary: [email.IsPrimary],
          ContactId: [email.ContactId],
          Deliverable: [email.Type, [undeliverableValidator()]],
        });
        this.existingEmailsForm.push(emailForm);
        return email;
      });
    } else {
      defaultForm = this.fb.group({});
      this.existingEmailsForm.push(defaultForm);
    }
  }

  updateEmail(oldData: EmailInfo, index: number): void {
    this.utils.showSpinner();
    this.notifi.clearAllNotifications();
    let notUnique = false;
    const formData = this.existingEmailsForm.at(index).value;
    // if the email is undeliverable and they changed it, let them proceed
    if (oldData.Type !== 'EMAIL') {
      if (oldData.Email !== formData.ExistingEmail) {
        this.existingEmailsForm.at(index).get('Deliverable')?.setErrors(null);
        this.existingEmailsForm.at(index).get('Deliverable')?.setValue('EMAIL');
        this.existingEmailsForm.at(index).get('Deliverable')?.updateValueAndValidity();
      }
    }
    const undeliverableOnFile = this.emailList.filter((email: EmailInfo) => {
      return email.Type !== 'EMAIL';
    });
    if (undeliverableOnFile.length > 0 && oldData.Type === 'EMAIL') {
      // if there are any undeliverable emails and they try to update a different email, force them to update undeliverable
      this.showUpdateUndeliverableMessage = true;
      this.notifi.addNotification(
        this.pageLabels.provideValidEmailMessage.replace('$EMAIL', undeliverableOnFile[0].Email),
        NotificationType.Alert,
        this.pageName,
      );
      this.utils.hideSpinner();
      return;
    }
    // if they do not have a primary, force them to choose a primary
    if (oldData.IsPrimary && !formData.SetPrimary) {
      this.notifi.addNotification(this.pageLabels.identifyPrimaryEmailError, NotificationType.Alert, this.pageName);
      this.utils.hideSpinner();
      return;
    }
    // the email address shouldn't match any other email on file
    const otherEmailsOnFile = this.emailList.filter((email: EmailInfo) => {
      return email.ContactId !== oldData.ContactId;
    });
    otherEmailsOnFile.forEach((email: EmailInfo) => {
      if (email.Email === formData.ExistingEmail) {
        notUnique = true;
      }
    });
    if (notUnique) {
      this.notifi.addNotification(this.pageLabels.mustBeUniqueError, NotificationType.Alert, this.pageName);
      this.utils.hideSpinner();
      return;
    }
    if (this.existingEmailsForm.at(index)?.valid) {
      const newEmail: EmailInfo = new EmailInfo();
      newEmail.ContactId = oldData.ContactId;
      newEmail.Email = formData.ExistingEmail;
      newEmail.IsActive = true;
      newEmail.IsPrimary = formData.SetPrimary;
      newEmail.Type = 'EMAIL';
      const persondData = this.accountDetail.Person;
      const alteredEmailId = oldData.ContactId;
      const newPrimary = formData.SetPrimary;
      const unchangedEmails = this.emailList.filter((item) => {
        return item.ContactId !== alteredEmailId;
      });
      if (newPrimary) {
        unchangedEmails.forEach((email) => {
          email.IsPrimary = false;
        });
      }
      unchangedEmails.push(newEmail);
      if (persondData?.EmailAddresses !== undefined) {
        persondData.EmailAddresses.length = 0;
      }
      unchangedEmails.forEach((email) => {
        persondData?.EmailAddresses?.push(email);
      });
      this.account
        .UpdatePersonContact(persondData)
        .pipe(
          catchError((e) => {
            this.utils.hideSpinner();
            this.notifi.addNotification(this.pageLabels.updateEmailApiError, NotificationType.Alert, this.pageName);
            return EMPTY;
          }),
        )
        .subscribe((data: any) => {
          this.accountDetail.Person = data;
          this.createCustomerContact('UPE', newEmail.Email);
          this.storage.setSession(StorageEnum.AccountDetail, this.accountDetail);
          this.existingEmailsForm.clear();
          this.accountDetail = this.storage.getSession(StorageEnum.AccountDetail);
          this.emailList = [];
          this.emailList = this.getEmailList();
          this.mapEmails();
          this.notifi.addNotification(
            this.pageLabels.emailAddressUpdatedText,
            NotificationType.Postnotification,
            this.pageName,
          );
          this.utils.hideSpinner();
        });
    } else {
      this.existingEmailsForm.at(index)?.markAllAsTouched();
      // if undeliverable email, do not let them enter the same email
      if (oldData.Type !== 'EMAIL') {
        if (oldData.Email === formData.ExistingEmail) {
          this.showUpdateUndeliverableMessage = true;
          this.notifi.addNotification(
            this.pageLabels.provideValidEmailMessage.replace('$EMAIL', oldData.Email),
            NotificationType.Alert,
            this.pageName,
          );
          this.utils.hideSpinner();
          return;
        }
      }
      const errorMessage = this.storage.getSession(StorageEnum.GlobalVars).formError;
      this.notifi.addNotification(errorMessage, NotificationType.Alert, this.pageName);
      this.utils.hideSpinner();
    }
  }

  removeEmail(oldData: EmailInfo): void {
    this.utils.showSpinner();
    this.notifi.clearAllNotifications();
    const deletedEmail = oldData.Email ?? '';
    const acctId = this.accountDetail.AccountNumber;
    const deletedContactId = oldData.ContactId;
    this.account
      .removeEmail(acctId, deletedEmail)
      .pipe(
        catchError((e) => {
          this.notifi.addNotification(this.pageLabels.removeEmailApiError, NotificationType.Alert, this.pageName);
          this.utils.hideSpinner();
          return EMPTY;
        }),
      )
      .subscribe((data: any) => {
        this.createCustomerContact('UPE', deletedEmail);
        const remainingEmails = this.emailList.filter((email: EmailInfo) => {
          return email.ContactId !== deletedContactId;
        });
        if (this.accountDetail.Person?.EmailAddresses) {
          this.accountDetail.Person.EmailAddresses = [];
          remainingEmails.forEach((email: EmailInfo) => {
            this.accountDetail.Person?.EmailAddresses?.push(email);
          });
        }
        this.storage.setSession(StorageEnum.AccountDetail, this.accountDetail);
        this.existingEmailsForm.clear();
        this.accountDetail = this.storage.getSession(StorageEnum.AccountDetail);
        this.emailList = [];
        this.emailList = this.getEmailList();
        this.mapEmails();
        this.notifi.addNotification(
          this.pageLabels.emailAddressUpdatedText,
          NotificationType.Postnotification,
          this.pageName,
        );
        this.utils.hideSpinner();
      });
  }

  addEmail(): void {
    this.utils.showSpinner();
    this.notifi.clearAllNotifications();
    if (this.newEmailForm.valid) {
      const newEmail: EmailInfo = new EmailInfo();
      newEmail.ContactId = '';
      newEmail.Email = this.newEmailForm.get('newEmail')?.value;
      newEmail.IsActive = true;
      newEmail.IsPrimary = true;
      newEmail.Type = 'EMAIL';
      const persondData = this.accountDetail.Person;
      persondData?.EmailAddresses?.push(newEmail);
      this.account
        .UpdatePersonContact(persondData)
        .pipe(
          catchError((e) => {
            this.notifi.addNotification(this.pageLabels.addEmailApiError, NotificationType.Alert, this.pageName);
            this.utils.hideSpinner();
            return EMPTY;
          }),
        )
        .subscribe((data: any) => {
          this.accountDetail.Person = data;
          this.createCustomerContact('UPE', newEmail.Email);
          this.storage.setSession(StorageEnum.AccountDetail, this.accountDetail);
          this.existingEmailsForm.clear();
          this.accountDetail = this.storage.getSession(StorageEnum.AccountDetail);
          this.emailList = [];
          this.emailList = this.getEmailList();
          this.mapEmails();
          this.notifi.addNotification(
            this.pageLabels.emailAddressUpdatedText,
            NotificationType.Postnotification,
            this.pageName,
          );
          this.utils.hideSpinner();
        });
    } else {
      this.newEmailForm.markAllAsTouched();
      const errorMessage = this.storage.getSession(StorageEnum.GlobalVars).formError;
      this.notifi.addNotification(errorMessage, NotificationType.Alert, this.pageName);
      this.utils.hideSpinner();
    }
  }

  cancelChanges(oldData: EmailInfo, index: number): void {
    this.existingEmailsForm.at(index).setValue({
      ExistingEmail: oldData.Email,
      SetPrimary: oldData.IsPrimary,
      ContactId: oldData.ContactId,
      Deliverable: oldData.Type,
    });
  }

  mapPhones(): void {
    let phoneForm, defaultForm;
    if (this.phoneList.length > 0) {
      this.phoneList.map((phone) => {
        phoneForm = this.fb.group({
          ExistingPhone: [phone.Number, [Validators.required]],
          SetPrimary: [phone.IsPrimary],
          ContactId: [phone.ContactId],
          PhoneType: [phone.Type, [Validators.required]],
          Order: [phone.Order],
        });
        this.existingPhonesForm.push(phoneForm);
        return phone;
      });
    } else {
      defaultForm = this.fb.group({});
      this.existingPhonesForm.push(defaultForm);
    }
  }

  updatePhone(oldData: PhoneInfo, index: number): void {
    this.utils.showSpinner();
    this.notifi.clearAllNotifications();
    const errorMessage = this.storage.getSession(StorageEnum.GlobalVars).formError;
    let notUnique = false;
    const formData = this.existingPhonesForm.at(index).value;
    // if they do not have a primary, force them to choose a primary
    if (oldData.IsPrimary && !formData.SetPrimary) {
      this.notifi.addNotification(this.pageLabels.primaryPhoneErrorText, NotificationType.Alert, this.pageName);
      this.utils.hideSpinner();
      return;
    }
    // the email address shouldn't match any other email on file
    const otherPhonesOnFile = this.phoneList.filter((phone: PhoneInfo) => {
      return phone.ContactId !== oldData.ContactId;
    });
    otherPhonesOnFile.forEach((phone: PhoneInfo) => {
      if (phone.Number === formData.ExistingPhone) {
        notUnique = true;
      }
    });
    if (notUnique) {
      this.notifi.addNotification(errorMessage, NotificationType.Alert, this.pageName);
      this.existingPhonesForm.at(index).get('ExistingPhone')?.setErrors({ notUnique: true });
      this.utils.hideSpinner();
      return;
    }
    if (formData.PhoneType !== 0 && formData.PhoneType !== 1) {
      this.notifi.addNotification(errorMessage, NotificationType.Alert, this.pageName);
      this.existingPhonesForm.at(index).get('PhoneType')?.setErrors({ required: true });
      this.existingPhonesForm.at(index).get('PhoneType')?.markAsTouched();
      this.utils.hideSpinner();
      return;
    }
    if (this.existingPhonesForm.at(index)?.valid) {
      const newPhone: PhoneInfo = new PhoneInfo();
      newPhone.ContactId = oldData.ContactId;
      newPhone.Number = formData.ExistingPhone;
      newPhone.IsActive = true;
      newPhone.IsPrimary = formData.SetPrimary;
      newPhone.Type = formData.PhoneType;
      newPhone.Order = oldData.Order;
      const persondData = this.accountDetail.Person;
      const alteredPhoneId = oldData.ContactId;
      const newPrimary = formData.SetPrimary;
      const unchangedPhones = this.phoneList.filter((item) => {
        return item.ContactId !== alteredPhoneId;
      });
      if (newPrimary) {
        unchangedPhones.forEach((phone) => {
          phone.IsPrimary = false;
        });
      }
      unchangedPhones.push(newPhone);
      if (persondData?.PhoneNumbers !== undefined) {
        persondData.PhoneNumbers.length = 0;
      }
      unchangedPhones.forEach((phone) => {
        persondData?.PhoneNumbers?.push(phone);
      });
      this.account
        .UpdatePersonContact(persondData)
        .pipe(
          catchError((e) => {
            this.utils.hideSpinner();
            this.notifi.addNotification(this.pageLabels.updatePhoneApiErrorText, NotificationType.Alert, this.pageName);
            return EMPTY;
          }),
        )
        .subscribe((data: any) => {
          this.accountDetail.Person = data;
          this.createCustomerContact(
            'UPH',
            this.getPhoneCustomerContactEmail(),
            `Phone updated: ${oldData.Number ?? ''} to ${newPhone.Number ?? ''}`,
          );
          this.storage.setSession(StorageEnum.AccountDetail, this.accountDetail);
          this.existingPhonesForm.clear();
          this.accountDetail = this.storage.getSession(StorageEnum.AccountDetail);
          this.phoneList = [];
          this.phoneList = this.getPhoneList();
          this.mapPhones();
          this.notifi.addNotification(
            this.pageLabels.updatePhoneApiSuccess,
            NotificationType.Postnotification,
            this.pageName,
          );
          this.utils.hideSpinner();
        });
    } else {
      this.existingEmailsForm.at(index)?.markAllAsTouched();
      this.notifi.addNotification(errorMessage, NotificationType.Alert, this.pageName);
      this.utils.hideSpinner();
    }
  }

  addPhone(dir: FormGroupDirective): void {
    this.utils.showSpinner();
    this.notifi.clearAllNotifications();
    const errorMessage = this.storage.getSession(StorageEnum.GlobalVars).formError;
    if (this.phoneList.length > 0) {
      // check for unique
      let unique = true;
      const newPhone = this.newPhoneForm.get('newNumber')?.value;
      this.phoneList.forEach((phone: PhoneInfo) => {
        if (phone.Number === newPhone) {
          unique = false;
        }
      });
      if (!unique) {
        this.notifi.addNotification(errorMessage, NotificationType.Alert, this.pageName);
        this.newPhoneForm.get('newNumber')?.setErrors({ notUnique: true });
        this.utils.hideSpinner();
        return;
      }
    }
    if (this.newPhoneForm.valid) {
      const newPhone: PhoneInfo = new PhoneInfo();
      const oldPhones: PhoneInfo[] = [];
      this.phoneList.forEach((phone: PhoneInfo) => {
        oldPhones.push(phone);
      });
      newPhone.ContactId = '';
      newPhone.Number = this.newPhoneForm.get('newNumber')?.value;
      newPhone.IsActive = true;
      newPhone.IsPrimary = this.newPhoneForm.get('newPrimary')?.value;
      newPhone.Type = this.newPhoneForm.get('newType')?.value;
      newPhone.Order = 0;
      const persondData = this.accountDetail.Person;
      if (newPhone.IsPrimary) {
        oldPhones.forEach((phone: PhoneInfo) => {
          phone.IsPrimary = false;
        });
      }
      oldPhones.push(newPhone);
      if (persondData?.PhoneNumbers !== undefined) {
        persondData.PhoneNumbers.length = 0;
      }
      oldPhones.forEach((phone: PhoneInfo) => {
        persondData?.PhoneNumbers?.push(phone);
      });
      this.account
        .UpdatePersonContact(persondData)
        .pipe(
          catchError((e) => {
            this.utils.hideSpinner();
            this.notifi.addNotification(this.pageLabels.addPhoneApiErrorText, NotificationType.Alert, this.pageName);
            return EMPTY;
          }),
        )
        .subscribe((data: any) => {
          this.accountDetail.Person = data;
          this.createCustomerContact(
            'UPH',
            this.getPhoneCustomerContactEmail(),
            `Phone added: ${newPhone.Number ?? ''}`,
          );
          this.storage.setSession(StorageEnum.AccountDetail, this.accountDetail);
          this.existingPhonesForm.clear();
          dir.resetForm();
          this.newPhoneForm.patchValue({
            newNumber: '',
            newType: 0,
            newPrimary: false,
          });
          this.accountDetail = this.storage.getSession(StorageEnum.AccountDetail);
          this.phoneList = [];
          this.phoneList = this.getPhoneList();
          this.mapPhones();
          this.notifi.addNotification(
            this.pageLabels.addPhoneApiSuccessText,
            NotificationType.Postnotification,
            this.pageName,
          );
          this.utils.hideSpinner();
        });
    } else {
      this.newPhoneForm.markAllAsTouched();
      this.notifi.addNotification(errorMessage, NotificationType.Alert, this.pageName);
      this.utils.hideSpinner();
    }
  }

  cancelPhoneChanges(oldData: PhoneInfo, index: number): void {
    this.existingPhonesForm.at(index).setValue({
      ExistingPhone: oldData.Number,
      SetPrimary: oldData.IsPrimary,
      ContactId: oldData.ContactId,
      PhoneType: oldData.Type,
      Order: oldData.Order,
    });
  }

  removePhone(oldData: PhoneInfo): void {
    this.utils.showSpinner();
    this.notifi.clearAllNotifications();
    const removedPhoneId = oldData.ContactId;
    const newPhones = this.phoneList.map((phone: PhoneInfo) => {
      if (phone.ContactId === removedPhoneId) {
        return { ...phone, IsActive: false };
      }
      return phone;
    });
    const persondData = this.accountDetail.Person;
    if (persondData?.PhoneNumbers !== undefined) {
      persondData.PhoneNumbers.length = 0;
    }
    newPhones.forEach((phone: PhoneInfo) => {
      persondData?.PhoneNumbers?.push(phone);
    });
    this.account
      .UpdatePersonContact(persondData)
      .pipe(
        catchError((e) => {
          this.utils.hideSpinner();
          this.notifi.addNotification(this.pageLabels.removePhoneErrorMessage, NotificationType.Alert, this.pageName);
          return EMPTY;
        }),
      )
      .subscribe((data: any) => {
        this.accountDetail.Person = data;
        this.createCustomerContact(
          'UPH',
          this.getPhoneCustomerContactEmail(),
          `Phone deleted: ${oldData.Number ?? ''}`,
        );
        this.storage.setSession(StorageEnum.AccountDetail, this.accountDetail);
        this.existingPhonesForm.clear();
        this.phoneList = [];
        this.phoneList = this.getPhoneList();
        this.mapPhones();
        this.notifi.addNotification(
          this.pageLabels.removePhoneSuccessMessage,
          NotificationType.Postnotification,
          this.pageName,
        );
        this.utils.hideSpinner();
      });
  }

  getEmailList(): EmailInfo[] {
    const emailList: EmailInfo[] = [];
    this.accountDetail?.Person?.EmailAddresses?.forEach((emailItem) => {
      emailList.push(emailItem);
    });
    return this.sortEmailsByPrimary(emailList);
  }

  sortEmailsByPrimary(emails: EmailInfo[]): EmailInfo[] {
    emails.sort((a, b) => {
      const firstEmail = a.IsPrimary ?? false;
      const secondEmail = b.IsPrimary ?? false;
      return Number(secondEmail) - Number(firstEmail);
    });
    return emails;
  }

  getPhoneList(): PhoneInfo[] {
    const phoneList: PhoneInfo[] = [];
    this.accountDetail?.Person?.PhoneNumbers?.forEach((phoneItem) => {
      phoneList.push(phoneItem);
    });
    return this.sortPhonesByPrimary(phoneList);
  }

  sortPhonesByPrimary(phones: PhoneInfo[]): PhoneInfo[] {
    phones.sort((a, b) => {
      const firstPhone = a.IsPrimary ?? false;
      const secondPhone = b.IsPrimary ?? false;
      return Number(secondPhone) - Number(firstPhone);
    });
    return phones;
  }

  disablePrimaryCheckbox(e: Event, index: number): void {
    if (this.emailList.length === 1) {
      e.preventDefault();
      this.existingEmailsForm.at(index).get('SetPrimary')?.setValue(true);
    }
  }

  checkEmailsMatch(): void {
    const newEmail = this.newEmailForm.get('newEmail');
    const newEmailConfirm = this.newEmailForm.get('newEmailConfirm');
    if (
      !(newEmail?.value.length > 0 && newEmailConfirm?.value.length > 0 && newEmail?.value === newEmailConfirm?.value)
    ) {
      newEmailConfirm?.setErrors({ doNotMatch: true });
    }
  }

  cancelNewEmail(): void {
    this.newEmailForm.reset({ newEmail: '', newEmailConfirm: '' });
  }

  cancelNewPhone(dir: FormGroupDirective): void {
    dir.resetForm();
    this.newPhoneForm.reset();
    this.newPhoneForm.patchValue({
      newNumber: ' ',
      newType: 0,
      newPrimary: true,
    });
    this.newPhoneForm.get('newNumber')?.updateValueAndValidity();
  }

  private createCustomerContact(contactType: 'UPE' | 'UPH', email?: string, comments?: string): void {
    const customerContact = new CreateCustomerContact();
    customerContact.AccountNumber = this.accountDetail.AccountNumber;
    customerContact.ContactType = contactType;
    customerContact.Email = email;
    customerContact.Comments = comments;
    customerContact.CustomerContactCharacteristic = [
      {
        CharacteristicType: 'REQSRCE',
        CharacteristicValue: Capacitor.getPlatform() === 'web' ? 'OAS' : 'MOBILE',
      },
    ];

    this.customer
      .createCustomerContact(customerContact)
      .pipe(catchError(() => EMPTY))
      .subscribe();
  }

  private getPhoneCustomerContactEmail(): string | undefined {
    return this.emailList.find((email) => email.IsPrimary)?.Email ?? this.emailList[0]?.Email;
  }

  async goToManageAccount(): Promise<void> {
    await this.router.navigateByUrl(Nav.ManageAccount);
  }

  getBtnAriaLabels(contactName: any, action: string): string {
    if (action === 'update') {
      return 'Update ' + contactName + ' details';
    }
    if (action === 'cancel') {
      return 'Cancel ' + contactName + ' changes';
    }
    return 'Remove ' + contactName;
  }

  formatPhoneInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    const input = target.value.replace(/\D/g, '').substring(0, 10); // First ten digits of input only
    const areaCode = input.substring(0, 3); // Area code
    const prefix = input.substring(3, 6); // Prefix
    const lineNumber = input.substring(6, 10); // Line number
    if (input.length > 6) {
      target.value = '(' + areaCode + ')' + ' ' + prefix + '-' + lineNumber;
    } else if (input.length > 3) {
      target.value = '(' + areaCode + ')' + ' ' + prefix;
    } else if (input.length > 0) {
      target.value = areaCode;
    }
  }
}
